import { translate } from 'components/Translation';
import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { CREATE_OFFLINE_PAYMENT_STATUS } from 'views/BillingPaymentTrack/RegisteringNewPayment';
import CustomConfirmationDialog from 'components/CustomConfirmationDialog/CustomConfirmationDialog';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { BodyM, HeadingS } from 'components/Typography/Typography';

interface IUploadedFilesDialog {
	isOpen: boolean;
	hideDialog: () => void;
	createOfflinePaymentStatus: CREATE_OFFLINE_PAYMENT_STATUS;
	ticketExternalId: string;
}

const CreateOfflinePaymentStatusDialog = ({
	isOpen,
	hideDialog,
	createOfflinePaymentStatus,
	ticketExternalId,
}: IUploadedFilesDialog) => {
	return (
		<CustomConfirmationDialog
			isOpen={isOpen}
			hideDialog={hideDialog}
			noMargin={true}
			isError={createOfflinePaymentStatus === CREATE_OFFLINE_PAYMENT_STATUS.ERROR}
			withoutIcon={createOfflinePaymentStatus === CREATE_OFFLINE_PAYMENT_STATUS.LOADING}
			width={350}
			padding={'16px 16px'}
		>
			<ConditionalRender
				show={createOfflinePaymentStatus === CREATE_OFFLINE_PAYMENT_STATUS.LOADING}
				onTrue={() => (
					<div>
						<BodyM>
							<>{translate('loading')}</>
						</BodyM>
						<CircularProgress />
					</div>
				)}
				onFalse={() => (
					<ConditionalRender
						show={createOfflinePaymentStatus === CREATE_OFFLINE_PAYMENT_STATUS.DONE}
						onTrue={() => (
							<>
								<BodyM>{translate('prepaid.loyalty.success')}</BodyM>
								<HeadingS color="success">
									{translate('billing.payment.track.success.body', ticketExternalId)}
								</HeadingS>
							</>
						)}
						onFalse={() => (
							<ConditionalRender
								show={createOfflinePaymentStatus === CREATE_OFFLINE_PAYMENT_STATUS.ERROR}
								onTrue={() => (
									<>
										<BodyM>{translate('something.went.wrong')}</BodyM>
										<HeadingS color="danger">
											{translate('billing.payment.track.error.body')}
										</HeadingS>
									</>
								)}
								onFalse={() => <></>}
							/>
						)}
					/>
				)}
			/>
		</CustomConfirmationDialog>
	);
};

export default CreateOfflinePaymentStatusDialog;
